import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/cdm-security-monitoring/',
    name: 'CDM Security Monitoring',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, __, next) {
        if (!hasAccessAll([
          'cdm-monitoring:read', // for alert codes: 122, 127, 128, 129
          'cdm-monitoring:update',
          'z1b-itemp:read', // for alert codes: 18
          'z1f-idoor:read', // for alert codes: 19
          'e1o-general-camera-offline:read' // for alert codes: 126
        ])) {
          return next({ name: '403'})
        }

        Helper.methods.userLogging('Access', _)
        next()
      }
    },
    component: () => import('@/router/views/cdm-security-monitoring/'),
  },
]